import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);


import is_mobile_view from "../app/helpers";

/**
 * Return the parents div for the projects list
 * @returns {Element}
 */
let tween_square = null;
let tween_global = null;
let tween_square2 = null;
let tween_circle = null;
let tweenScroll = null;
let interval_square_circle_anim= null;

const get_anim_el = (container) => container.querySelector('#anim_square_circle');

const init_circle_square = (container) => {
    const elem = get_anim_el(container);
    if( elem ){
        // console.log("INIT : anim circle square");
        tween_square = gsap.to("#square_part", {duration:30, rotate:'+=360deg', ease:"none", repeat : -1 });
        tween_global = gsap.to(elem, {duration:30, rotate:'+=360deg', ease:"none", repeat : -1 });
        interval_square_circle_anim = setInterval(updateSquare, 5000);
        updateSquare();


        tweenScroll = gsap.to(elem, {
            ease: 'power1.out',
            scrollTrigger: {
                start : "top 0%",
                end: "top -90%",
                scrub: true,
                 // markers:true,
                toggleActions : "play none none none",
            },
            yPercent: '-300',
            alpha:0,
        });
    }
}

const updateSquare = () => {
    let randomX,
        randomY;
    if(is_mobile_view()){
        randomX = "random(-30, 30)";
        randomY = "random(-30, 70)";
    }else{
        randomX = "random(-40, 00)";
        randomY = "random(-40, 90)";
    }
    tween_square2 = gsap.to("#square_part", {duration:20, ease:"none", x: randomX, y: randomY})
    tween_circle = gsap.to("#circle_part", {duration:20, ease:"none", x: randomX, y: randomY})
}

const desinit_circle_square = (container) => {
    const elem = get_anim_el(container);
    if( elem ){
        // console.log("DESINIT : anim circle square");
        clearInterval(interval_square_circle_anim);
        tween_global.kill()
        tween_square.kill();
        tween_square2.kill();
        tween_circle.kill();
        tweenScroll.kill();
        tween_square = null;
        tween_square2 = null;
        tween_circle = null;
        tweenScroll = null;
        tween_global = null;
        interval_square_circle_anim = null;
    }
}

export {init_circle_square, desinit_circle_square}